<template>
  <v-layout column fill-height>
    <breadcrumbs
      guia="Início"
      titulo="Início"
      descricao="Seja bem-vindo(a) ao Portal do Corretor. Escolha ao lado o menu que deseja acessar."
    />
    <v-layout class="main overflow-y-auto">
      <v-flex>
        <v-layout row class="content-body" style="height: 210px">
          <v-flex md12 style="padding: 5px">
            <v-card
              class="text-center text-white"
              color="#00abe4"
              style="
                height: 200px;
                background: url('/upload/banner-segurado-empresarial.png') center center;
                background-repeat: no-repeat;
                background-size: cover;
              "
              outlined
            >
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="content-body" style="height: 210px">
        <v-flex md4 style="padding: 5px">
          <v-card
            class="text-center text-white"
            href="https://wa.me/551130038533"
            target="_blank"
            color="#25d366"
            style="
              height: 200px;
              background: url('/upload/Inicio/BANNER_PORTAL_CORRETOR_WHATS.png') center
                center;
              background-repeat: no-repeat;
              background-size: cover;
            "
            outlined
          >
            <!-- background-image: url('/upload/Inicio/BANNER_PORTAL_ESTIPULANTE_WHATS.jpg'); -->
            <!-- <div style="padding:20px; ">
                <img src="/img/icon-whatsapp.png" width="34" height="34" /><br />
                <span>Previsul Soluciona<br /> agora no WhatsApp</span><br /><br />
                <span style="font-size:20px;margin-bottom:20px;">51 9 8268 0607</span><br />
                <a href="https://api.whatsapp.com/send?phone=5551982680607" target="_blank" class="text-white custom-link" style="text-decoration:underline;">Acesse aqui</a>                  
              </div> -->
          </v-card>
        </v-flex>
      </v-layout>
      </v-flex>
    </v-layout>

    <div class="text-center">
      <v-overlay :value="fullLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <BannerSantander />
      <Aceite />
    </div>
  </v-layout>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import Helpers from "@/utilities/Helpers";
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import Aceite from "@/components/portal/layout/Aceite";
import BannerSantander from "@/components/portal/layout/BannerSantander";

export default {
  mixins: [Helpers],
  components: {
    breadcrumbs,
    Aceite,
    BannerSantander,
  },
  data() {
    return {
      fullLoading: false,
      loading: false,

      sinistros: [],
      noDataText: "Nenhuma informação pesquisada",
      sinistroSemTMA: false,

      subject: "",
      samlResponseAvisoSinistro: "",
      urlPostSalesForce: process.env.VUE_APP_SSO_SALES_FORCE,
    };
  },
  methods: {
    async enviarRequisicao() {
      let userId = this.usuarioInfo && this.usuarioInfo.userId != null
        ? this.usuarioInfo.userId
        : localStorage.getItem("userId");

      // Sem userId não há como montar a requisição do SSO de Aviso de Sinistro;
      // aborta silenciosamente para não travar o carregamento da home.
      if (userId == null || userId === "") {
        return;
      }

      let request = {
        subject: this.subject,
        tipoPortal: 1,
      };

      let paramsRequestContaContato = {
        tipoPortal: 1, //Aviso Sinistro ou Portal Corretor
        userId: userId.toString(),
        personId: parseInt(localStorage.getItem("personId")),
      };

      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
          // Evita que a home fique presa caso o endpoint não responda (homol).
          timeout: 15000,
        };
        const resultCriacaoContaContato = await Vue.prototype.$httpIdentityServerApi.post(
          "person/createUserContactSF",
          paramsRequestContaContato,
          config
        );

        if (resultCriacaoContaContato.status === 200) {

          const resultAvisoSinistro = await Vue.prototype.$httpPortal.post(
            "SAML/getSAMLResponse",
            request,
            { timeout: 15000 }
          );

          this.samlResponseAvisoSinistro = resultAvisoSinistro.data.ObjetoRetorno;

          //document.getElementById('btnLoginAvisoSinistroSF').click();
        }
      } catch (ex) {
        console.log(ex);
      }
    },
  },
  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo", usuarioInfo: "getUsuario" }),
  },

  mounted() {
    let cnpjCorretor = localStorage.getItem("cpfCnpj");
    let userCpf = localStorage.getItem("userCpf");
    this.subject = cnpjCorretor + "_" + userCpf;

    // Pré-fetch do SSO de Aviso de Sinistro: roda em segundo plano e NÃO bloqueia
    // a renderização da home. Erros/timeouts são tratados dentro de enviarRequisicao.
    this.enviarRequisicao();
  },
};
</script>
